<template>
  <b-form class="restricted-msisdn">
    <slot name="txtBefore"></slot>
    <b-row>
      <b-col>
        <div :id="'msisdn_wrapper' + _uid" role="group" :class="{ 'form-group': true, 'error': isValid('msisdn') === false, 'success': isValid('msisdn') === true }">
          <label id="msisdn__BV_label_" :for="'msisdn' + _uid" :class="{ 'd-block customLabel': true, 'error': isValid('msisdn') === false, 'success': isValid('msisdn') === true }">
            <dyn-slot :slot-data="slotData"><slot name="lblMsisdn" >Die Rufnummer Ihres Vertrages</slot></dyn-slot></label>
          <b-form-input
            :id="'msisdn' + _uid"
            name="msisdn"
            required
            v-model.trim="msisdn"
            data-msisdn
            type="text"
            @input="$v.msisdn.$touch"
            :state="isValid('msisdn')"
          ></b-form-input>
        </div>
      </b-col>
    </b-row>
    <slot name="txtAfter"></slot>
    <Stepper
      :show-prev="false"
      @next="next()"
      :disabled-next="$v.$invalid || loading"
      :loading-next="loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </b-form>
</template>

<script>

import Stepper from '@/components/generic/Stepper.vue'
import { BCol, BRow, BForm, BFormInput } from 'bootstrap-vue'
import processSteps from '@/mixins/processSteps'
import { mapGetters, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'
import preFilledInput from '@/mixins/preFilledInput'
import { helpers, required } from 'vuelidate/lib/validators'
import slotProxy from '@/mixins/slotProxy'

const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9]*$/)

export const stepName = 'queryMSISDN'

export default {
  name: 'InputMsisdn',
  components: { Stepper, BCol, BRow, BForm, BFormInput },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async next () {
      this.loading = true
      await this.setMsisdn({ msisdn: this.msisdn, nextStep: this.nextStep })
      this.loading = false
    },
    ...mapActions({
      setMsisdn: 'setRestrictedLoginMsisdn'
    })
  },
  mixins: [
    processSteps(stepName, stepName, stepName),
    validationMixin,
    isValid,
    preFilledInput('msisdn', 'getMsisdn'),
    slotProxy()
  ],
  validations () {
    return {
      msisdn: {
        required,
        isPhoneNumber
      }
    }
  },
  computed: {
    slotData () {
      return {
        loading: this.loading
      }
    },
    ...mapGetters({
      getMsisdn: 'getRestrictedLoginMsisdn'
    })
  }
}
</script>
